<template>
  <v-card flat>
    <v-card class="px-2" :key="'dir-' + index" v-for="(direction, key, index) in stat">
      <v-card-text>
        <h4 class="blue--text">
          <v-icon small>{{dir ? 'flight_takeoff' : 'flight_land' }}</v-icon>
          {{key}}
        </h4>
        <v-expansion-panel class="elevation-0 b-exppansion">
          <v-expansion-panel-content
            class="small-exppansion"
            v-for="(ak, akkey, index) in stat[key]"
            :key="'ak-' + index"
          >
            <template v-slot:header>
              <div>{{akkey}}</div>
            </template>
            <v-card class="pb-3">
              <v-data-table
                :headers="detailHeaders"
                :items="ak"
                hide-actions
                disable-initial-sort
                no-data-text="Нет данных"
                item-key="Month"
                class="elevation-0 small-detail-table"
              >
                <template v-slot:items="props">
                  <td
                    v-for="(col, index) in detailHeaders"
                    :key="'td-detail-'+index"
                  >{{ props.item[col.value] }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      detailHeaders: [
        { text: 'Тип ВС', value: 'TS' },
        { text: 'Кресел', value: 'KR' },
        { text: 'Рейсов', value: 'CNTFL' },
        { text: 'Пассажиры', value: 'PAX' },
        { text: 'Загрузка (%)', value: 'LOAD' },
      ],
    }
  },
  props: ['stat', 'dir'],
}
</script>
